import React from 'react';
import {ItemPresenter} from "../ItemPresenter";

const className = "deerpelt";

function GIDeerPelt() {
  return (
    <ItemPresenter imagePath={`/images/gameItems/${className}.png`} tooltipText={className} />
  );
}

export default GIDeerPelt;